import type {
  CompanyListItemFragment,
  GameConsoleListItemFragment,
  GameListItemFragment,
  GameSeriesListItemFragment,
  MediaDetailsFragment,
  TagListItemFragment,
  UpdateMediaMutationVariables,
} from "../graphql/types"
import type { OrderRaw } from "../components/order"

export const ORDER_STORAGE_KEY = "nfans.media.order"
export const SCALE_STORAGE_KEY = "nfans.media.scale"
export const VIEW_STORAGE_KEY = "nfans.media.view"
export const TAGS_STORAGE_KEY = "nfans.media.tags"
export const COMPANIES_STORAGE_KEY = "nfans.media.companies"
export const GAME_CONSOLES_STORAGE_KEY = "nfans.media.gameConsoles"
export const GAME_SERIES_STORAGE_KEY = "nfans.media.gameSeries"
export const GAMES_STORAGE_KEY = "nfans.media.games"

export const MEDIA_ORDER_PROPERTIES: Array<OrderRaw> = [
  {
    label: "Dateiname",
    properties: [{ property: "filename", defaultDirection: "asc" }]
  },
  {
    label: "Dateityp",
    properties: [{ property: "mediaType", defaultDirection: "asc" }]
  },
  {
    label: "Größe",
    properties: [{ property: "length", defaultDirection: "asc" }]
  },
  {
    label: "Erstellungsdatum",
    properties: [{ property: "createdDate", defaultDirection: "desc" }]
  },
  {
    label: "Zuletzt Geändert",
    properties: [{ property: "lastModifiedDate", defaultDirection: "desc" }]
  }
]

export interface MediaFormData {
  uuid: string
  filename: string
  basename: string
  copyright: string
  copyrightUrl: string
  license: string
  licenseUrl: string
  sourceUrl: string
  watermark: boolean
  tags: TagListItemFragment[]
  companies: CompanyListItemFragment[]
  gameSeries: GameSeriesListItemFragment[]
  games: GameListItemFragment[]
  gameConsoles: GameConsoleListItemFragment[]
}

export function createEmptyMediaFormData(): MediaFormData {
  return {
    uuid: "",
    filename: "",
    basename: "",
    copyright: "",
    copyrightUrl: "",
    license: "",
    licenseUrl: "",
    sourceUrl: "",
    watermark: false,
    tags: [],
    companies: [],
    gameSeries: [],
    games: [],
    gameConsoles: []
  }
}

export function toMediaFormData(
  media: MediaDetailsFragment
): MediaFormData {
  const index = media.filename.lastIndexOf(".")
  const basename = index >= 0 ? media.filename.substring(0, index) : ""

  return {
    uuid: media.uuid,
    filename: media.filename,
    basename: basename || "",
    copyright: media.copyright || "",
    copyrightUrl: media.copyrightUrl || "",
    license: media.license || "",
    licenseUrl: media.licenseUrl || "",
    sourceUrl: media.sourceUrl || "",
    watermark: media.watermark,
    tags: media.tags ?? [],
    companies: media.companies ?? [],
    gameSeries: media.gameSeries ?? [],
    games: media.games ?? [],
    gameConsoles: media.gameConsoles ?? []
  }
}

export function toUpdateInput(media: MediaFormData): UpdateMediaMutationVariables {
  const {
    uuid,
    filename,
    basename,
    copyright,
    copyrightUrl,
    license,
    licenseUrl,
    sourceUrl,
    watermark,
    tags,
    companies,
    gameSeries,
    games,
    gameConsoles
  } = media

  const index = filename.lastIndexOf(".")
  const extension = index >= 0 ? filename.substring(index) : ""

  return {
    id: uuid,
    update: {
      filename: basename + extension,
      copyright,
      copyrightUrl,
      license,
      licenseUrl,
      sourceUrl,
      watermark,
      tags: tags.map(t => t.uuid),
      companies: companies.map(c => c.uuid),
      gameSeries: gameSeries.map(s => s.uuid),
      games: games.map(g => g.uuid),
      gameConsoles: gameConsoles.map(c => c.uuid)
    }
  }
}
